const FORKTO_DOMAIN_SUFFIX = ".forkto.com";
const URL_SCHEME_PATTERN = /^[a-z][a-z0-9+.-]*:\/\//i;

export function normalizeCustomerID(value) {
    const raw = String(value ?? "").trim().toLowerCase().replace(/\s+/g, "");
    if (!raw) return "";

    const urlCandidate =
        URL_SCHEME_PATTERN.test(raw) || raw.startsWith("//") ? raw : `https://${raw}`;

    let host = raw;
    try {
        host = new URL(urlCandidate).hostname;
    } catch {
        host = raw;
    }

    host = host.replace(/\.+$/, "");
    if (host.startsWith("www.")) {
        host = host.slice(4);
    }
    if (host.endsWith(FORKTO_DOMAIN_SUFFIX)) {
        host = host.slice(0, -FORKTO_DOMAIN_SUFFIX.length);
    }
    if (host.includes(".")) {
        host = host.split(".")[0];
    }

    return host.replace(/[^a-z0-9-]/g, "");
}
